import React from "react";
import { KoText, KoTooltips } from "../index";
import KoIcon from '@kwapio/icons';
import styles from './priority.module.scss';

function KoPriority(props) {
  const { size, value, text = true } = props;

  const priorityList = [
    { label: "Lowest", color: "#028759" },
    { label: "Low", color: "#00a3bf" },
    { label: "Medium", color: "#ff991f" },
    { label: "High", color: "#e75167" },
    { label: "Highest", color: "#de350c" }
  ];

  const priority = priorityList[value];

  if (!priority) return null;

  return (
    <div className={styles.priorityWrapper}>
      <KoTooltips title={`${priority.label} Priority`}>
        <div className={styles.priority}>
          <div className={styles.priorityStatus}>
            <KoIcon
              name={'FlagOutlined'}
              width={14}
              height={14}
              color={ priority.color}
            />
            {text && (
              <KoText
                className={size === 'small' ? styles.smallSize : ''}
                text={priority.label}
                style={{ color: priority.color, marginLeft: 4 }}
              />
            )}
          </div>
        </div>
      </KoTooltips>
    </div>
  );
}

export default KoPriority;
